module.exports = __webpack_public_path__ + "static/sport/registeractive.a3e8024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/registeractive.png
// module id = gSCj
// module chunks = 0